/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../_metronic/helpers'
import {useDLMTypesQueryRequest} from './DLMTypesQueryRequestProvider'

import { getDLMTypes, DLMType } from '../'


const DLMTypesQueryResponseContext = createResponseContext<DLMType>(initialQueryResponse)
const DLMTypesQueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useDLMTypesQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const { isFetching, refetch, data: response} = useQuery(
    `DLMTYPESLIST`,
    () => { return getDLMTypes(); },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <DLMTypesQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </DLMTypesQueryResponseContext.Provider>
  )
}

const useDLMTypesQueryResponse = () => useContext(DLMTypesQueryResponseContext)

const useDLMTypesQueryResponseData = () => {
  const {response} = useDLMTypesQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useDLMTypesQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useDLMTypesQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useDLMTypesQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMTypesQueryResponse()
  return isLoading
}

export {
  DLMTypesQueryResponseProvider,
  useDLMTypesQueryResponse,
  useDLMTypesQueryResponseData,
  useDLMTypesQueryResponsePagination,
  useDLMTypesQueryResponseLoading,
}
